import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Marketplace } from './marketplace.model';
import { MarketplaceService } from './marketplace.service';
@Injectable()
export class MarketplacePopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketplaceService: MarketplaceService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketplaceService.find(id).subscribe((marketplace) => {
                marketplace.updated = this.datePipe
                    .transform(marketplace.updated, 'yyyy-MM-ddThh:mm');
                marketplace.created = this.datePipe
                    .transform(marketplace.created, 'yyyy-MM-ddThh:mm');
                this.marketplaceModalRef(component, marketplace);
            });
        } else {
            return this.marketplaceModalRef(component, new Marketplace());
        }
    }

    marketplaceModalRef(component: Component, marketplace: Marketplace): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketplace = marketplace;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace-popup.service.ts